const extractPriceAndSortFilters = (url: string): string => {
    const regex = /-?minprice-\d{1,8}-maxprice-\d{1,8}|-?isort-.*$/g
    const matched = url.match(regex)
    return matched ? matched.join("") : ""
}

export default extractPriceAndSortFilters
